import { useMemo } from 'react';

import { getBrowserFriendlyColor } from './color/colorUtils';

function useBrowserColor<T extends string | undefined>(color: T): T {
  return useMemo(() => (color ? getBrowserFriendlyColor(color) : undefined), [color]) as T;
}

export default useBrowserColor;
